<template>
    <div>
        <section class="edit-page" style="overflow: hidden; display:flex; flex-direction: column; padding-bottom:0px;" v-if="isShow">
            <div class="top-btns type1" style="padding-left: 20px;">
                <a class="close" @click="close">닫기</a>
                <span style="font-weight:500;">{{title}}</span>
            </div>

            <div class="content" style="overflow:auto; flex:1;">
                <p class="tit">{{noticeDetail.title}}</p>
                <p class="date" v-if="noticeDetail.notice_date">등록일 : {{noticeDetail.notice_date | dotDate}} / {{noticeDetail.notice_date.substr(11, 5)}}</p>

                <div style="white-space: pre-wrap;font-size: 14px;line-height: 20px;">{{noticeDetail.contents}}</div>
                <div v-for="each, i in images" :key="i" style="">
                    <div class="img-box">
                        <img style="width:100%;" :src="$resourcePath + each.file_path">
                    </div>
                </div>
            </div>
            <div style="height:70px; padding:10px;" v-if="noticeDetail.action" @click="doAction">
                <div style="display:grid;place-items: center; border-radius:25px; background-color: black; height:50px; width:100%; color:white; ">{{noticeDetail.btn_name}}</div>
            </div>
        </section>

    </div>
</template>

<script>
    export default {
        name: "NotificationDetail",
        props: {
            idx : String,
            title : String,
        },
        data(){
            return {
                notice : null,
                images : null,
                isShow : false,
                noticeDetail : {}
            }
        },
        methods : {
            async getNoticeDetail(){
                const parameters = {idx : this.idx};
                const res = await this.$Axios.get('/api/noticeDetail', {params : parameters});

                this.noticeDetail = res.data.notice;

                this.notice = res.data.notice;

                this.images = res.data.images;
            },
            close(){
                this.$GlobalStore.closeLastModal();
            },
            doAction(){
                if(this.noticeDetail.notice_type === '이벤트' || this.noticeDetail.notice_type === '이벤트_c') {
                    this.$Util.sendEventClick('마이_이벤트_상세_화면이동버튼');
                }else if(this.noticeDetail.notice_type === '공지사항' || this.noticeDetail.notice_type === '공지사항_c'){
                    this.$Util.sendEventClick('마이_공지사항_상세_화면이동버튼');
                }

                if(this.noticeDetail.idx == '27'){
                    this.$GlobalStore.closeModalAll();
                }

                window.pushCustomManager.goScreen(null, null, this.noticeDetail.action,  this.noticeDetail.param1);
            }
        },
        mounted(){
            setTimeout(() => {
                this.isShow = true;
            }, 300);
        },
        created(){
            this.getNoticeDetail();
        }
    }
</script>

<style scoped>
    .top-btns { height: 60px; border-bottom: 1px solid; border-color: #F5F5F5; padding-top: 7px; box-sizing: border-box; text-align: center; }
    .top-btns h2 { padding: 0; display: inline-block; border-bottom: none; line-height: 53px; }

    .edit-page .top-btns.type1 { height:70px; border-bottom: 1px solid #F5F5F5; text-align: left;width: 100%; }
    .edit-page .top-btns.type1 .close { font-size: 0; width: 45px; height:45px; position: relative; vertical-align: middle; }
    .edit-page .top-btns.type1 .close:after { content: ''; width:22px; height:22px; background: url("~@/assets/images/mypage/ico-close.png")0 0 no-repeat; background-size: contain;display:inline-block; }
    .edit-page .top-btns.type1 span { font-size: 16px; line-height: 53px; font-weight: 500; vertical-align: middle; display: inline-block; margin-left: 25px; margin-top: 6px; }

    .content { text-align: left; padding: 20px; height: 100%; overflow: auto; }
    .content .tit { font-size: 20px; line-height: 29px; }
    .content .date { font-size: 14px; line-height: 20px; color:#808080; margin-bottom: 30px; }
    .content .txt { font-size: 14px; line-height: 20px; }
    .content ol { padding-left: 20px; box-sizing: border-box; }
    .content ol li { font-weight: 700; line-height: 20px; }
    .content .img-box {font-size: 0px; width: 100%; margin-top: 30px; border-radius: 5px; box-shadow: 0 5px 10px 0 rgba(16, 16, 20, 0.2); position: relative; }
    .content .img-box img {  }
    .edit-page {padding-bottom: 70px; box-sizing: border-box; margin-top: 0; }
    .btn-wrap { width: 100%; position: absolute; left:0; bottom: 30px; text-align: center; }
    .btn { font-size: 20px; font-weight: 500; text-align: center; border: 1px solid; border-color: var(--color-main); line-height: 44px; width:274px; height:46px; border-radius: 23px; cursor:pointer; }
    .btn.update { color:var(--color-main); margin-bottom: 15px; }


</style>